import gql from 'graphql-tag';

const GET_CRE_COMPANY_BASELINE = gql`
  query($input: RuleConditionInput!) {
    getCRECompanyBaselineMetrics(input: $input)
  }
`;

const GET_FILTER_INPUTS = gql`
  query($input: CustomFilterInput!) {
    getCustomFilterValues(input: $input)
  }
`;

const GET_WORKLOG_HOURS_LOGGED = gql`
  query($input: ClientRankingByWorklogHoursInput!) {
    getClientRankingByWorklogHoursLogged(input: $input)
  }
`;

const GET_CLIENT_SPECIFIC_EFFICIENCY = gql`
  query($input: ClientSpecificEfficiencyInput!) {
    getClientSpecificEfficiency(input: $input)
  }
`;

const GET_CLIENT_EFFICIENCY_RANKING = gql`
  query($input: ClientEfficiencyRankingInput!) {
    getClientEfficiencyRanking(input: $input)
  }
`;

const GET_CRE_TREND_ANALYSIS = gql`
  query($input: CRETrendAnalysisInput!) {
    getCRETrendAnalysis(input: $input)
  }
`;

const GET_TICKET_LIST_CRE = gql`
  query($input: CRETicketsByCategoryInput!) {
    getCRETicketsByCategory(input: $input)
  }
`;

const GET_CONTRACT_REVENUE_METRICS = gql`
  query($input: ClientIdentifierInput) {
    getContractRevenueMetrics(input: $input) {
      monthlyRecurringRevenue
      yearlyRecurringRevenue
      revenueYTD
      profit
    }
  }
`;

const GET_ACTIVE_RECURRING_REVENUE = gql`
  query($input: ClientIdentifierInput) {
    getActiveRecurringRevenue(input: $input) {
      monthly
      yearly
    }
  }
`;

const GET_MOTHLY_REVENUE = gql`
  query($input: ListInfoInput!) {
    getMonthlyRevenue(input: $input)
  }
`;

const GET_TOP_CLIENTS_BY_FINANCE = gql`
  query($input: ListInfoInput!) {
    getTopClientsByFinancialSegments(input: $input) {
      client {
        name
        accountId
      }
      financialPerformanceMetric {
        revenue
        profit
        hoursInvested
        effectiveRate
        profitPercentage
      }
    }
  }
`;

const GET_CLIENT_FINANCIAL_PERFORMANCE = gql`
  query($input: ListInfoInput!) {
    getClientFinancialPerformanceMetrics(input: $input) {
      clientFinancialPerformanceMetrics {
        client {
          name
        }
        financialPerformanceMetric {
          revenue
          profit
          hoursInvested
          effectiveRate
          profitPercentage
        }
      }
      listInfo {
        page
        pageSize
        condition
        totalCount
        hasMore
      }
    }
  }
`;

const GET_TOP_CONTRACTS_BY_FINANCE = gql`
  query($input: ListInfoInput!) {
    getTopContractsByFinancialSegments(input: $input) {
      contract {
        name
      }
      financialPerformanceMetric {
        revenue
        profit
        hoursInvested
        effectiveRate
        profitPercentage
      }
    }
  }
`;

const GET_CONTRACT_FINANCIAL_PERFORMANCE = gql`
  query($input: ListInfoInput!) {
    getContractFinancialPerformanceMetrics(input: $input) {
      contractFinancialPerformanceMetrics {
        contract {
          name
        }
        financialPerformanceMetric {
          revenue
          profit
          hoursInvested
          effectiveRate
          profitPercentage
        }
      }
      listInfo {
        page
        pageSize
        condition
        totalCount
        hasMore
      }
    }
  }
`;

const GET_LABOUR_REVENUE = gql`
  query($input: ListInfoInput!) {
    getLabourRevenue(input: $input) {
      revenue
      effectiveRevenue
    }
  }
`;

const GET_MONTHLY_LABOUR_REVENUE = gql`
  query($input: ListInfoInput!) {
    getMonthlyLabourRevenue(input: $input)
  }
`;

const GET_SERVICE_UTILISATION = gql`
  query($input: ListInfoInput!) {
    getServiceUtilisation(input: $input) {
      serviceUtilisationList {
        serviceCatalog {
          name
        }
        billedHours
        revenue
      }
      listInfo {
        page
        pageSize
        condition
        totalCount
        hasMore
      }
    }
  }
`;
const GET_TECHNICIAN_UTILISATION = gql`
  query($input: ListInfoInput!) {
    getTechnicianUtilisation(input: $input) {
      technicianUtilisationList {
        user {
          userId
          email
          firstName
          lastName
          name
        }
        billedHours
        revenue
        cost
        profit
      }
      listInfo {
        page
        pageSize
        condition
        totalCount
        hasMore
      }
    }
  }
`;

const GET_GROWTH_REPORT_CONFIGURATION = gql`
  query {
    getReportCalculationStatus
  }
`;

export {
  GET_CRE_COMPANY_BASELINE,
  GET_FILTER_INPUTS,
  GET_WORKLOG_HOURS_LOGGED,
  GET_CLIENT_SPECIFIC_EFFICIENCY,
  GET_CLIENT_EFFICIENCY_RANKING,
  GET_CRE_TREND_ANALYSIS,
  GET_TICKET_LIST_CRE,
  GET_ACTIVE_RECURRING_REVENUE,
  GET_MOTHLY_REVENUE,
  GET_TOP_CLIENTS_BY_FINANCE,
  GET_CLIENT_FINANCIAL_PERFORMANCE,
  GET_TOP_CONTRACTS_BY_FINANCE,
  GET_CONTRACT_FINANCIAL_PERFORMANCE,
  GET_LABOUR_REVENUE,
  GET_MONTHLY_LABOUR_REVENUE,
  GET_SERVICE_UTILISATION,
  GET_TECHNICIAN_UTILISATION,
  GET_GROWTH_REPORT_CONFIGURATION,
  GET_CONTRACT_REVENUE_METRICS
};
